export const menuData = [
    { title: "home" }, 
    { title: "about" },
    { title: "skills" },
    { title: "portfolio" },
    { title: "contact" },
];
